export default "__VITE_ASSET__DIzhG6XE__"